
import service from "../services/remissions.service"; // Asegúrate de que el servicio esté configurado correctamente

export const remissions = {
    namespaced: true,
    state: {
        data: [],
        currentPage: 1,
        lastPage: 1,
        links:[],
        getData:[],
    },
    getters: {
        allData: (state) => state.data,
        pagination: (state) => ({
            currentPage: state.currentPage,
            lastPage: state.lastPage,
        }),
        links: (state) => state.links,
        getData: (state) => state.getData,
    },
    actions: {
        async fetchData({ commit },data = null) {
            try {
                const response = await service.getAll(data); 

                commit('SET_DATA', response.data.data); 
                commit('SET_PAGINATION', {
                    currentPage: response.data.current_page,
                    lastPage: response.data.last_page,
                    links: response.data.links, // Agrega los links de paginación aquí
                });
            } catch (error) {
                console.error("Error fetching proyects:", error);
            }
        },
        async save(context,data) {
            try {
                let response;
                if(!data.id || data.id == 0){
                    response = await service.createData(data);
                }else{
                    response = await service.updateData(data.id,data);
                }
                return response; 
            } catch (error) {
                console.error("Error save projects:", error);
                return error.response; 
            }
        },
        async delete(context, userId) {
            try {
                const response = await service.deleteData(userId);
                return response; // Puedes retornar la respuesta si es necesario
            } catch (error) {
                throw error.response; ; // Propaga el error para que sea manejado en el componente
            }
        },
        async getData({ commit }, id) {
            try {
                const response = await service.getData(id);
                commit('SET_GET_DATA', response.data);
                return response;
            } catch (error) {
                console.error("Error fetching get data:", error);
                throw error.response;
            }
        },
        async getAll(context, params = {}) {
            try {
                const response = await service.getAll({ page: 'all', ...params });
                return response.data;
            } catch (error) {
                console.error("Error fetching get data:", error);
                throw error.response;
            }
        },  
        async getDoc(context, id) {
            try {
                const response = await service.getDoc(id);
                return response.data;
            } catch (error) {
                console.error("Error fetching get data:", error);
                throw error.response;
            }
        },
        async getPublicPdfLink(context, id) {
            try {
                return await service.getPublicPdfLink(id);
            } catch (error) {
                console.error("Error fetching public PDF link:", error);
                throw error.response;
            }
        },
        async getDocPOS(context, id) {
            try {
                const response = await service.getDocPOS(id);
                return response.data; // Retornar el texto directamente
            } catch (error) {
                console.error("Error fetching POS document:", error);
                throw error.response;
            }
        },
        async getDocPOSHtml(context, id) {
            try {
                const response = await service.getDocPOSHtml(id);
                return response.data;
            } catch (error) {
                console.error("Error fetching POS HTML ticket:", error);
                throw error.response;
            }
        },
        async exportData(context, filters = {}) {
            try {
                const response = await service.exportData(filters);
                return response;
            } catch (error) {
                console.error("Error exporting data:", error);
                throw error.response;
            }
        },  
    },
    mutations: {
        SET_DATA(state, data) {
            state.data = data;
        },
        SET_PAGINATION(state, pagination) {
            state.currentPage = pagination.currentPage;
            state.lastPage = pagination.lastPage;
            state.links = pagination.links;
        },
        ADD_DATA(state, data) {
            state.data.push(data); // Agrega el nuevo usuario al array de usuarios
        },
        SET_GET_DATA(state, data) {
            state.getData = data;
        }
    },
};